module.exports = __webpack_public_path__ + "img/VetoSansCond-Medium.60d0970b.svg";